import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../styles/AboutPage.css";
import ClientsMarquee from "./ClientsMarquee";

/* ─── ICONS (inline SVG to avoid react-icons dependency issues) ─── */
const IconBaby = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-2 5h4a2 2 0 0 1 2 2v4l1.5 3H6.5L8 13V9a2 2 0 0 1 2-2zm-5 13v-1a7 7 0 0 1 14 0v1H5z" /></svg>;
const IconUsers = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05C16.19 13.89 17 14.6 17 15.5V19h7v-2.5c0-2.33-4.67-3.5-7-3.5z" /></svg>;
const IconStore = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4v2l8 5 8-5V4zm0 4-8 5-8-5v10h16V8z" /></svg>;
const IconTshirt = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16 4.2 20.4 8l-1.4 1.4L17 7.5V19H7V7.5L5 9.4 3.6 8 8 4.2c.3.5.8.9 1.4 1.1L12 6l2.6-.7c.6-.2 1.1-.6 1.4-1.1z" /></svg>;
const IconUserTie = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a5 5 0 1 0 0 10A5 5 0 0 0 12 2zm0 12c-5.33 0-8 2.67-8 4v2h16v-2c0-1.33-2.67-4-8-4z" /></svg>;
const IconChart = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M3.5 18.5 9 13l4 4L20 7.5" /><path d="M3.5 18.5 9 13l4 4L20 7.5" stroke="currentColor" strokeWidth="2" fill="none" /></svg>;
const IconLeaf = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17 8C8 10 5.9 16.17 3.82 21.34L5.71 22l1-2.3A4.49 4.49 0 0 0 8 20C19 20 22 3 22 3c-1 2-8 2-5 8z" /></svg>;
const IconPalette = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5S18.33 12 17.5 12z" /></svg>;
const IconCheck = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" /></svg>;
const IconRocket = () => <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.5s4.5 2 4.5 9.5c0 3.5-2 5.5-4.5 8-2.5-2.5-4.5-4.5-4.5-8C7.5 4.5 12 2.5 12 2.5zm0 6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-4 11 1.5-2.5h5L16 19.5l-4 2.5-4-2.5z" /></svg>;
const IconArrow = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M12 5l7 7-7 7" /></svg>;

/* ─── DATA ─────────────────────────────── */
const STATS = [
  { number: "63+", label: "Years of Heritage", icon: <IconBaby /> },
  { number: "10,000+", label: "Happy Customers", icon: <IconUsers /> },
  { number: "600+", label: "Whole Sellers", icon: <IconStore /> },
  { number: "101+", label: "Products", icon: <IconTshirt /> },
  { number: "75+", label: "Employees", icon: <IconUserTie /> },
  { number: "27,000+", label: "Pincode Coverage", icon: <IconChart /> },
];

const VALUES = [
  { icon: <IconLeaf />, title: "Pure Cotton", desc: "100% combed compact cotton — skin-friendly, breathable, and built to last generations." },
  { icon: <IconPalette />, title: "Bold Designs", desc: "From timeless classics to vivid prints — patterns that carry a story in every thread." },
  { icon: <IconCheck />, title: "Quality First", desc: "Every product is inspected for colour, weave, and finish before it reaches your hands." },
  { icon: <IconRocket />, title: "Innovation", desc: "Pioneers of washed ready-to-wear dhotis — always pushing what textile can be." },
];

const FACTSHEET = [
  { label: "Nature of Business", value: "Manufacturer, Supplier, Wholesaler" },
  { label: "Additional Type", value: "Wholesale Supplier, Producers & Maker, Online Reseller" },
  { label: "Established", value: "1961" },
  { label: "Key Segments", value: "Apparel & Garments, Sarees" },
  { label: "Legal Status", value: "Partnership" },
  { label: "Employees", value: "101 – 500 People" },
  { label: "Annual Turnover", value: "₹25 – 50 Crore" },
  { label: "GST No", value: "33AAFXK1445J1ZO" },
  { label: "Delivery Time", value: "4 to 6 Days" },
  { label: "Payment", value: "Cash, Mobile / Net Banking" },
  { label: "Packaging", value: "Customized, Courier Bags, Plywood Box" },
  { label: "Shipping", value: "By Cargo, By Air" },
];

// const DEALS = [
//   { icon: "🪡", title: "Manufacturer of Cotton Saree" },
//   { icon: "🏷️", title: "KKB Brand Dealer" },
// ];

const PRODUCTS = [
 "Bed Linen", "Bath Linen", "Jambura Half Sleeves", "Jambura Full Sleeves", "Premium Printed Lumgies", "Checked Lungies", "Kaavi & Dhoti", "Bedsheets", "Chennimalai Bedsheets", "Towels",
];

const FAQS = [
  {
    q: "Which is the nearest landmark to K K Balusamy Co?",
    a: "You can easily find K K Balusamy Co from Erode Central — one of the most famous landmarks in the city."
  },
  {
    q: "What modes of payment are accepted?",
    a: "K K Balusamy Co accepts all major payment methods including Cash and Mobile / Net Banking."
  },
  {
    q: "What types of dhotis are available at K K Balusamy Co?",
    a: "We offer a wide range of dhotis including Cotton Dhotis, Border Dhotis, KKB Dhotis, Traditional Dhotis, and Temple-use Dhotis."
  },
  {
    q: "Do you sell Kaavi (Saffron) clothing products?",
    a: "Yes, we provide quality Kaavi products including Kaavi Dhotis, Kaavi Towels, and other traditional spiritual wear."
  },
  {
    q: "Are towels available in different sizes and qualities?",
    a: "Yes, our collection includes cotton towels in various sizes, colors, and fabric qualities suitable for daily and ceremonial use."
  },
  {
    q: "Do you offer bedsheets for home use?",
    a: "Yes, we offer comfortable and durable bedsheets in different designs, sizes, and fabric varieties."
  },
  {
    q: "What is the minimum price range for KKB Dhoti?",
    a: "Minimum price starts from ₹125 at K K Balusamy Co."
  }
];

/* ─── HOOKS ─────────────────────────────── */
function useParallax(speed = 0.3) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onScroll = () => {
      const rect = el.getBoundingClientRect();
      const offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * speed;
      el.style.transform = `translateY(${offset}px)`;
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [speed]);
  return ref;
}

function useReveal(threshold = 0.15) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { el.classList.add("ap-revealed"); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return ref;
}

function useCountUp(target, duration = 1800, trigger) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!trigger) return;
    const num = parseFloat(target.replace(/[^0-9.]/g, ""));
    const suffix = target.replace(/[0-9.]/g, "");
    let start = null;
    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      setCount(Math.floor(ease * num) + suffix);
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [trigger, target, duration]);
  return count || "0";
}

/* ─── STAT CARD (with count-up) ─────────── */
function StatCard({ stat, triggered }) {
  const num = useCountUp(stat.number, 1600, triggered);
  return (
    <div className="apstat-card">
      <div className="apstat-icon">{stat.icon}</div>
      <div className="apstat-number">{num}</div>
      <div className="apstat-label">{stat.label}</div>
    </div>
  );
}

/* ─── TRANSFORMATION SECTION ─────────────── */
function TransformationSection() {
  const sectionRef = useRef(null);
  const sliderRef = useRef(null);
  const [revealed, setRevealed] = useState(false);
  const [sliderPos, setSliderPos] = useState(50);
  const [isDragging, setIsDragging] = useState(false);

  /* Trigger reveal on scroll */
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setRevealed(true); obs.disconnect(); } },
      { threshold: 0.15 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  /* Drag / touch logic */
  const getPos = (e, rect) => {
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    return Math.min(100, Math.max(0, ((x - rect.left) / rect.width) * 100));
  };

  const onMouseDown = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  useEffect(() => {
    if (!isDragging) return;
    const el = sliderRef.current;
    const rect = el.getBoundingClientRect();
    const move = (e) => setSliderPos(getPos(e, rect));
    const up = () => setIsDragging(false);
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("touchend", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("touchend", up);
    };
  }, [isDragging]);

  const onSliderClick = (e) => {
    const rect = sliderRef.current.getBoundingClientRect();
    setSliderPos(getPos(e, rect));
  };

  return (
    <section className={`aptransform${revealed ? " aptransform--revealed" : ""}`} ref={sectionRef}>
      {/* ── Cinematic background ── */}
      <div className="aptransform-bg" />

      <div className="aptransform-inner">
        {/* ── Header ── */}
        <div className="aptransform-header">
          <span className="apeyebrow apeyebrow--light">The Journey</span>
          <h2 className="apsection-heading apsection-heading--light">
            From Humble Roots<br />
            <em>to a Landmark</em>
          </h2>
          <p className="aptransform-subtext">
            Drag the divider to witness six decades of transformation — from a single storefront in 1961
            to the iconic KKB tower that defines Erode's textile skyline.
          </p>
        </div>

        {/* ── Comparison Slider ── */}
        <div
          className="aptransform-slider"
          ref={sliderRef}
          onClick={onSliderClick}
          style={{ cursor: isDragging ? "grabbing" : "ew-resize" }}
        >
          {/* BEFORE — 1961 */}
          <div className="aptransform-side aptransform-side--before">
            <img
              src="/assets/kkbold.png"
              alt="KKB & Co. in 1961"
              className="aptransform-img"
            />
            <div className="aptransform-overlay aptransform-overlay--before" />
            <div className="aptransform-label aptransform-label--before">
              <span className="aptransform-label-year">1961</span>
              <span className="aptransform-label-text">The Beginning</span>
            </div>
            {/* Film-grain for vintage feel */}
            <div className="aptransform-grain" />
          </div>

          {/* AFTER — Now (clipped by slider) */}
          <div
            className="aptransform-side aptransform-side--after"
            style={{ clipPath: `inset(0 0 0 ${sliderPos}%)` }}
          >
            <img
              src="/assets/kkbnow.png"
              alt="KKB & Co. Today"
              className="aptransform-img"
            />
            <div className="aptransform-overlay aptransform-overlay--after" />
            <div className="aptransform-label aptransform-label--after">
              <span className="aptransform-label-year">Today</span>
              <span className="aptransform-label-text">The Legacy</span>
            </div>
          </div>

          {/* Divider line + handle */}
          <div
            className="aptransform-divider"
            style={{ left: `${sliderPos}%` }}
            onMouseDown={onMouseDown}
            onTouchStart={onMouseDown}
          >
            <div className="aptransform-divider-line" />
            <div className="aptransform-handle">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="16" cy="16" r="15" fill="rgba(54,4,5,0.92)" stroke="#b8860b" strokeWidth="1.5" />
                <path d="M10 16l-4 0M10 16l-3-3M10 16l-3 3" stroke="#b8860b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22 16l4 0M22 16l3-3M22 16l3 3" stroke="#b8860b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
        </div>

        {/* ── Timeline strip ── */}
        <div className="aptransform-timeline">
          {[
            { year: "1961", desc: "Two-storey corner shop, bicycles outside, a dream inside" },
            { year: "1975", desc: "Invented the Printed Lungi — industry changed overnight" },
            { year: "1995", desc: "Expanded to multi-floor operations; 600+ wholesalers onboarded" },
            { year: "2021", desc: "Diamond Jubilee — the iconic KKB tower stands tall in Erode" },
          ].map((t, i) => (
            <div key={i} className="aptransform-tick" style={{ "--tick-delay": `${i * 0.15 + 0.4}s` }}>
              <div className="aptransform-tick-dot" />
              <span className="aptransform-tick-year">{t.year}</span>
              <p className="aptransform-tick-desc">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ─── MAIN COMPONENT ─────────────────────── */
export default function AboutPage() {
  const [openFaq, setOpenFaq] = useState(null);
  const [statTriggered, setStatTriggered] = useState(false);

  /* parallax layers */
  const heroImgRef = useParallax(0.18);
  const bgPara1 = useParallax(0.18);
  const bgPara2 = useParallax(-0.12);

  /* reveal refs */
  const aboutReveal = useReveal(0.1);
  const valuesReveal = useReveal(0.1);
  const founderReveal = useReveal(0.1);
  const statsRef = useRef(null);
  const dealsReveal = useReveal(0.1);
  const factReveal = useReveal(0.1);
  const faqReveal = useReveal(0.1);
  const contactReveal = useReveal(0.1);

  /* stat counter trigger */
  useEffect(() => {
    const el = statsRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setStatTriggered(true); obs.disconnect(); } },
      { threshold: 0.2 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div className="aproot">

      {/* ══════════ HERO ══════════ */}
      <section className="aphero">

        {/* ── Cinematic background image with parallax ── */}
        <div className="aphero-img-wrap" ref={heroImgRef}>
          <img
            src="/assets/hh.jpg"
            alt="K.K. Balusamy & Co. — Erode"
            className="aphero-bg-img"
          />
        </div>

        {/* ── Cinematic overlay layers ── */}
        <div className="aphero-overlay aphero-overlay--base" />
        <div className="aphero-overlay aphero-overlay--gradient" />
        <div className="aphero-overlay aphero-overlay--vignette" />
        <div className="aphero-overlay aphero-overlay--noise" />

        {/* ── Decorative rings (kept, now on top of image) ── */}
        <div className="aphero-circle aphero-circle--1" ref={bgPara1} />
        <div className="aphero-circle aphero-circle--2" ref={bgPara2} />
        <div className="aphero-circle aphero-circle--3" />

        {/* ── Location watermark ── */}
        <div className="aphero-location-tag">
          <span className="aphero-location-dot" />
          No. 1, South Hanumantharayan Kovil St., Erode
        </div>

        <div className="aphero-content">
          <span className="aphero-badge">Est. 1961 · Diamond Jubilee · Erode</span>
          <h1 className="aphero-title">
            K K Balusamy
            <br />
            <em className="aphero-title-em">&amp; Co.</em>
          </h1>
          <div className="aphero-ruled" />
          <p className="aphero-sub">
            Six decades of trust, quality &amp; an unconquerable spirit<br />
            woven into every thread of Indian textile heritage.
          </p>
          <div className="aphero-cta-row">
            <Link to="/collection" className="aphero-btn aphero-btn--primary">
              Explore Collection
            </Link>
            <a href="#about-story" className="aphero-btn aphero-btn--ghost">
              Our Story ↓
            </a>
          </div>
        </div>

        <div className="aphero-scroll-hint">
          <span className="aphero-scroll-line" />
          <span className="aphero-scroll-text">Scroll</span>
        </div>
      </section>

      {/* ══════════ ABOUT / STORY ══════════ */}
      <section className="apeditorial" id="about-story">
        <div className="apeditorial-inner" ref={aboutReveal}>
          <div className="apeditorial-left">
            <div className="apeditorial-img-frame">
              <img
                src="/assets/kkbstore.png"
                alt="KKB Textile"
                className="apeditorial-img"
              />
              <div className="apeditorial-img-badge">
                <span className="apeditorial-img-year">1961</span>
                <span className="apeditorial-img-since">Since</span>
              </div>
              <div className="apeditorial-img-border" />
            </div>
          </div>
         <div className="apeditorial-right">
  <span className="apeyebrow">Who We Are</span>

  <h2 className="apsection-heading">
    Diamond Jubilee
    <br />
    <em>in Textile Excellence</em>
  </h2>

  <div className="apruled-line" />

  <p className="aplede">
    We are one among the few longest serving textile companies in India. Our
    journey towards creating revolution in textiles was started in 1961 by our
    Founder & Chairman, <em>Shri. K. K. Balusamy</em>.
  </p>

  <p className="apbody-copy">
    Having sailed for six decades in textiles, we are presently headed by the
    second-generation entrepreneurs <em>Mr. Arunkumar Balusamy</em> and{" "}
    <em>Mrs. Manjula Vidyashankar</em>. We have completed our Diamond Jubilee
    in the textile field. The word <em>Diamond</em> in Greek{" "}
    <em>'adamus'</em> means <em>'unconquerable'</em>, the perfect epithet
    representing us.
    <br />
    <br />
    Currently, our company is run by a team of qualified professionals and has
    its presence across India, the Middle East, and Asia-Pacific countries.
    Apart from our traditional offerings—printed Lungi, which we invented,
    Dhothi, and Shirtings—we have ventured into the HomeTex division,
    predominantly catering to the hospital and hospitality sectors.
    <br />
    <br />
    As you read this, we are a 150-member team and are rapidly growing both in
    size and market presence. With our spirit of Trust, Quality, and
    Perseverance, we continuously strive to reinvent ourselves in tune with
    changing times. From a company with less than one lakh turnover in 1961,
    today we have grown into a multi-crore enterprise, supported by our
    tireless employees, valuable customers, and versatile vendors.
  </p>

  <div className="approduct-tags">
    {PRODUCTS.map((p) => (
      <span key={p} className="aptag">
        {p}
      </span>
    ))}
  </div>

  <Link to="/collection" className="aptext-link">
    Shop Our Collections <IconArrow />
  </Link>
</div>
        </div>
      </section>

      <ClientsMarquee />

      {/* ══════════ STATS ══════════ */}
      <section className="apstats-section" ref={statsRef}>
        <div className="apstats-parallax-bg" />
        <div className="apstats-inner">
          <div className="apstats-header">
            <span className="apeyebrow apeyebrow--light">By The Numbers</span>
            <h2 className="apsection-heading apsection-heading--light">
              Six Decades of <em>Impact</em>
            </h2>
          </div>
          <div className="apstats-grid">
            {STATS.map((s, i) => (
              <StatCard key={i} stat={s} triggered={statTriggered} />
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ TRANSFORMATION ══════════ */}
      <TransformationSection />

      {/* ══════════ FOUNDER ══════════ */}
      <section className="apfounder" ref={founderReveal}>
        <div className="apfounder-inner">
          <div className="apfounder-img-col">
            <div className="apfounder-photo-wrap">
              <img
                src="/assets/balu.png"
                alt="Mr. K.K. Balusamy"
                className="apfounder-photo"
              />
              <div className="apfounder-photo-ring" />
              <div className="apfounder-overlay-tag">
                <div className="apfounder-name">MR. K.K. BALUSAMY</div>
                <div className="apfounder-role">CEO &amp; Founder</div>
              </div>
            </div>
            <div className="apfounder-quote-card">
              <span className="apfounder-quote-mark">"</span>
              <p className="apfounder-quote-text">
                Knowledge hoarded is knowledge wasted. Share freely — that is how an industry grows.
              </p>
            </div>
          </div>
          <div className="apfounder-content-col">
            <span className="apeyebrow">About the Founder</span>
            <h2 className="apsection-heading">
              Saadhanai Chemmal
              <br />
              <em>The Kaili King</em>
            </h2>
            <div className="apruled-line" />
            <p className="aplede">
              Born January 1946, he sacrificed his dream of becoming a surgeon at
              age 16 to venture into textiles — and changed an entire industry.
            </p>
            <p className="apbody-copy">
              Fondly known as <strong>'Kaili King'</strong>, he is credited with
              the invention of the <strong> Printed Lungi</strong> — a breakthrough
              that transformed the lungi market forever. He introduced wax print,
              art print, spray print, and Procion print to the market, and evolved
              printing methods from Wooden Block to Table to Rotary.
            </p>
            <p className="apbody-copy">
              An ingrained philanthropist and known as{" "}
              <strong>'Kalvi Thanthai'</strong>, he never hoarded knowledge — he
              shared it freely. Today, he has handed over the reins to his
              children while serving society through educational institutions.
            </p>
            <div className="apfounder-milestones">
              {[
                { year: "1946", event: "Born in Erode" },
                { year: "1961", event: "Founded KKB & Co." },
                { year: "1975", event: "Invented Printed Lungi" },
                { year: "2021", event: "Diamond Jubilee" },
              ].map((m) => (
                <div key={m.year} className="apfounder-milestone">
                  <span className="apfounder-milestone-year">{m.year}</span>
                  <span className="apfounder-milestone-dot" />
                  <span className="apfounder-milestone-event">{m.event}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ══════════ VALUES ══════════ */}
      <section className="apvalues" ref={valuesReveal}>
        <div className="apvalues-inner">
          <div className="apvalues-header">
            <span className="apeyebrow">Our Philosophy</span>
            <h2 className="apsection-heading">
              What We Stand <em>For</em>
            </h2>
          </div>
          <div className="apvalues-grid">
            {VALUES.map((v, i) => (
              <div key={i} className="apval-card" style={{ "--ap-delay": `${i * 0.12}s` }}>
                <div className="apval-icon-wrap">{v.icon}</div>
                <h3 className="apval-title">{v.title}</h3>
                <p className="apval-desc">{v.desc}</p>
                <div className="apval-line" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ BUSINESS DEALS ══════════ */}
      {/* <section className="apdeals" ref={dealsReveal}>
        <div className="apdeals-parallax-bg" />
        <div className="apdeals-inner">
          <span className="apeyebrow apeyebrow--light">What We Do</span>
          <h2 className="apsection-heading apsection-heading--light">Business <em>Dealings</em></h2>
          <div className="apdeals-grid">
            {DEALS.map((d, i) => (
              <div key={i} className="apdeal-card" style={{ "--ap-delay": `${i * 0.1}s` }}>
                <span className="apdeal-icon">{d.icon}</span>
                <p className="apdeal-title">{d.title}</p>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* ══════════ FACTSHEET ══════════ */}
      <section className="apfact" ref={factReveal}>
        <div className="apfact-inner">
          <span className="apeyebrow">Company Details</span>
          <h2 className="apsection-heading">Company <em>Factsheet</em></h2>
          <div className="apfact-grid">
            {FACTSHEET.map((f, i) => (
              <div key={i} className="apfact-item" style={{ "--ap-delay": `${i * 0.05}s` }}>
                <span className="apfact-label">{f.label}</span>
                <span className="apfact-value">{f.value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ FAQ ══════════ */}
      <section className="apfaq" ref={faqReveal}>
        <div className="apfaq-inner">
          <span className="apeyebrow">Common Questions</span>
          <h2 className="apsection-heading">Questions &amp; <em>Answers</em></h2>
          <div className="apfaq-list">
            {FAQS.map((f, i) => (
              <div
                key={i}
                className={`apfaq-item${openFaq === i ? " apfaq-item--open" : ""}`}
                onClick={() => setOpenFaq(openFaq === i ? null : i)}
              >
                <div className="apfaq-q">
                  <span>{f.q}</span>
                  <span className="apfaq-toggle">{openFaq === i ? "−" : "+"}</span>
                </div>
                <div className={`apfaq-a-wrap${openFaq === i ? " apfaq-a-wrap--open" : ""}`}>
                  <p className="apfaq-a">{f.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════ FOOTER ══════════ */}
      <footer className="apfooter">
        <div className="apfooter-inner">
          <div className="apfooter-brand">K K Balusamy &amp; Co.</div>
          <p className="apfooter-meta">GST: 33AAFXK1445J1ZO &nbsp;·&nbsp; Erode, Tamil Nadu &nbsp;·&nbsp; Est. 1961</p>
          <div className="apfooter-social">
            <a href="https://www.facebook.com" target="_blank" rel="noreferrer" className="apfooter-social-link">FB</a>
            <a href="https://www.instagram.com" target="_blank" rel="noreferrer" className="apfooter-social-link">IG</a>
            <a href="https://api.whatsapp.com" target="_blank" rel="noreferrer" className="apfooter-social-link">WA</a>
          </div>
          <p className="apfooter-copy">© {new Date().getFullYear()} K K Balusamy &amp; Co. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}